import script from "./ar.vue?vue&type=script&setup=true&lang=js"
export * from "./ar.vue?vue&type=script&setup=true&lang=js"

import "./ar.vue?vue&type=style&index=0&id=3ef2fb68&lang=scss"

const __exports__ = script;

export default __exports__